/** Colunas do order by da pesquisa dos leads */
export enum LeadSearchOrderBy {
    DataCadastro = 1,
    Nome = 2,
    Email = 3,
    Telefone = 4,
    Celular = 5,
    NomeCidade = 6,
    UFEstado = 7,
    NomePais = 8,
    Temperatura = 9,
    NomeUsuarioResponsavel = 10,
    Origem = 11,
    NomeCampanhaOrigem = 12,
    CanalMidiaSocial = 13,
    NomeCampanhaQualificacao = 14
};
